var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-button",style:(_vm.iconSetter),attrs:{"id":"close-button"}},[_c('svg',{attrs:{"width":_vm.svgWidthHeight,"height":_vm.svgWidthHeight}},[_c('circle',{ref:"circle",style:(_vm.dashArray),attrs:{"cx":_vm.circleWidthHeight,"cy":_vm.circleWidthHeight,"r":_vm.radius}})]),_vm._v(" "),_c('div',{staticClass:"icon"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da05d0e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Atoms/CloseButton.vue
// module id = null
// module chunks = 